module.exports = __webpack_public_path__ + "img/3rd-Floor-SBM_SF-WFG-Airbnb-Ergo-Anywhere-smallest-e1638396496989.21c1028d.jpg";